import React from "react";
import { connect } from "react-redux";
import Wrap from "../wrap";
import A from "../a";
import "./styles.css";

const Footer = ({ routing }) => (
  <footer
    className={
      routing.locationBeforeTransitions.pathname === "/"
        ? "Footer homelg"
        : "Footer"
    }
  >
    <Wrap>
      <div className="footer-top">
        <div className="footer-links">
          <h3>Links</h3>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/articles">Articles</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/images">Product Images</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/instructions">Instructions</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/about-us">About Us</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/contact-us">Contact Us</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/terms-and-conditions-of-use">Terms & Conditions</A>
          </div>
          <div onClick={() => window.scrollTo(0, 0)}>
            <A href="/privacy-policy">Privacy Policy</A>
          </div>
        </div>
        <div className="address">
          <h3>Address</h3>
          <p>9450 SW Gemini Dr PMB</p>
          <p>84219</p>
          <p>Beaverton, OR 97008-7105</p>
          <p>United States</p>
        </div>
        <div className="companydetails">
          <h3>Company Details</h3>
          <p>Name: AuraSide, Inc.</p>
          <p>Registered Number: 61-1915221</p>
          <p>Contact Number: +1 (650) 337 0808</p>
        </div>
        <div className="footer-social">
          <h3>Find Us</h3>
          <a href="https://discordapp.com/invite/2veX8AT" target="_blank">
            Discord
          </a>
          <a href="https://twitter.com/ghastapp" target="_blank">
            Twitter
          </a>
          <a href="https://www.facebook.com/ghastapp" target="_blank">
            Facebook
          </a>
          <a href="https://www.youtube.com/c/Ghastio" target="_blank">
            YouTube
          </a>
          <a href="https://github.com/ghast" target="_blank">
            GitHub
          </a>
          <a href="https://www.trustpilot.com/review/ghast.io" target="_blank">
            TrustPilot
          </a>
        </div>
      </div>
      <p className="copyright">© {new Date().getFullYear()} AuraSide, Inc.</p>
    </Wrap>
  </footer>
);

const mapStateToProps = (state) => ({
  routing: state.routing,
});

export default connect(mapStateToProps)(Footer);



/** WEBPACK FOOTER **
 ** ./src/views/components/footer/index.js
 **/